var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5617 2.58539L9.62228 0.646393C9.52852 0.552658 9.40136 0.5 9.26879 0.5C9.13621 0.5 9.00905 0.552658 8.91529 0.646393C8.82156 0.740157 8.7689 0.867311 8.7689 0.999893C8.7689 1.13248 8.82156 1.25963 8.91529 1.35339L10.6928 3.13189H0.499988C0.367383 3.13189 0.240209 3.18457 0.146443 3.27834C0.0526772 3.37211 0 3.49928 0 3.63189H0C0 3.7645 0.0526772 3.89168 0.146443 3.98545C0.240209 4.07921 0.367383 4.13189 0.499988 4.13189H10.7233L8.91529 5.93939C8.86881 5.98583 8.83193 6.04097 8.80677 6.10167C8.7816 6.16237 8.76865 6.22744 8.76865 6.29314C8.76865 6.35885 8.7816 6.42391 8.80677 6.48461C8.83193 6.54531 8.86881 6.60046 8.91529 6.64689C9.00905 6.74063 9.13621 6.79329 9.26879 6.79329C9.40136 6.79329 9.52852 6.74063 9.62228 6.64689L11.5622 4.70739C11.8427 4.42548 12.0001 4.04396 12 3.64629C11.9999 3.24862 11.8423 2.86718 11.5617 2.58539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6bdc011835c52106f0f9e19f4e59e86c.svg";
export { ForwardRef as ReactComponent };